import Aifood from "../components/FeatureCardSection/sections/FeatureAiFoodDetection";
import Footer  from "../components/Footer/Footer";
export default function FeatureAiFoodDetection(){
  return (
    <>
    <Aifood />
    <Footer />
    </>
  );
}
